'use client'

import React from 'react'
import { Heading } from '@/components/ui/heading'
import { Text } from './ui/text'
import { Code } from './ui/code'
import { LinkButton } from './ui/LinkButton'
import { Separator } from './Separator'

export type SetupSidebarProps = {
  heading: string
  daemon: string
  links: {
    id: string
    label: string
    url: string
  }[]
}

export const SetupSidebar: React.FC<SetupSidebarProps> = ({ heading, daemon, links }) => {
  return (
    <div className="xl:max-w-[300px] flex flex-col gap-[40px]">
      <Heading size="h2" className="pb-[60px] text-balance">
        {heading}
      </Heading>

      <Separator color="rock-2" />
      <div className="flex flex-col gap-[30px]">
        <Heading size="h4" className="text-balance !leading-[1.15]">
          Ready to start the process?
        </Heading>

        <Text>
          Install <Code>{daemon}</Code>:
        </Text>

        <div className="flex flex-col md:flex-row xl:flex-col gap-[20px]">
          {links.map((link) => (
            <LinkButton
              key={link.id}
              href={link.url || ''}
              newTab
              linkIcon="external"
              variant="olive"
              className="flex justify-between"
            >
              {link.label}
            </LinkButton>
          ))}
        </div>
      </div>
      <Separator color="rock-2" />
      <div className="flex flex-col gap-[30px]">
        <Heading size="h5">Learn more about Sia</Heading>
        <div className="w-full md:w-fit xl:w-full">
          <LinkButton
            href="https://docs.sia.tech"
            newTab
            linkIcon="external"
            variant="outline-dark"
            className="flex justify-between"
          >
            View the Documentation
          </LinkButton>
        </div>
      </div>
    </div>
  )
}
